import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class RootService {
    timesheetPersmissionInfoSet = new BehaviorSubject<number>(null);
}
